import React from "react";
import "./Toast.scss";
import Button from "../LowLevel/Button/Button";
import { motion, AnimatePresence } from "framer-motion";

export default function Toast({
  formOpen,
  setFormOpen,
  words
}) {

  return (
    <AnimatePresence>
      {formOpen && (
        <motion.div
          initial={{ opacity: 0, y: 0, x: 0 }}
          animate={{ opacity: 1, y: 0, x: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ duration: 0.5 }}
          className="toast-consent-banner"
        >
          <div className="toast-consent-div">
            <div className="toast-message-parent">
              <Button
                onClick={() => setFormOpen(false)}
                aria-label="Dismiss message"
                aria-live="off"
                name="X"
                variant="toast"
                className="toast-x"
              />
              <div className="col toast-message-child">
                <p className="toast-message">{words.message}</p>
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
